import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { getUpdateBusinessState } from '@containers/businesses/businesses.selectors'
import {
  DownloadBusinessDocumentRequest,
  FetchBusinessDocumentsRequest,
  GenerateBusinessDocumentRequest,
  SetDefaultData,
} from '@containers/businesses/businesses.actions'
import { fromJS } from 'immutable'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { getUpdateCompoundState } from '@containers/compounds/compounds.selectors'
import {
  DeleteCompoundDocumentRequest,
  DownloadCompoundDocumentRequest,
  FetchCompoundDocumentsRequest,
  GenerateCompoundDocumentRequest,
} from '@containers/compounds/compounds.actions'

enum DATA_CYCLE_FILTER {
  Current,
  All,
}
@Component({
  selector: 'app-update-compound-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css'],
})
export class UpdateCompoundDocumentsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public compoundId: number
  public documents: any = fromJS([])
  private state$: Subscription
  public isLoading: boolean
  public isGenerating: boolean
  public isDeleting: boolean
  public columns = [
    {
      prop: 'referenceId',
      name: 'REFERENCE_ID',
    },
    {
      prop: 'dataCycle',
      name: 'YEAR',
      render: (row: any) => row.get('year'),
    },
    {
      prop: 'fileName',
      name: 'DOCUMENT_NAME',
    },
    {
      prop: 'generatedOn',
      name: 'GENERATED_AT',
      template: 'generatedOn',
    },
    {
      prop: 'download',
      template: 'actionDownload',
    },
  ]

  public radioOptions = [
    {
      label: 'CURRENT_ONLY',
      value: DATA_CYCLE_FILTER.Current,
    },
    {
      label: 'ALL_RECORDS',
      value: DATA_CYCLE_FILTER.All,
    },
  ]

  public dataCycle: DATA_CYCLE_FILTER = DATA_CYCLE_FILTER.Current
  public currentDataCycleId: any
  public settings$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.compoundId = parseInt(this.route.snapshot.paramMap.get('id'))

    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((settings) => {
        this.currentDataCycleId = settings.getIn([
          'data',
          'system',
          'SYSTEM_ACTIVE_DATA_CYCLE',
          'id',
        ])
      })

    this.state$ = this.store
      .pipe(select(getUpdateCompoundState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.getIn(['documents', 'isLoading'])
        this.isGenerating = state.getIn([
          'documents',
          'generateDocumentLoading',
        ])

        this.isDeleting = state.getIn(['documents', 'deleteDocumentLoading'])

        this.documents = this.filterDocuments(
          state.getIn(['documents', 'data']),
        )
      })

    this.store.dispatch<any>(new FetchCompoundDocumentsRequest(this.compoundId))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.settings$.unsubscribe()
  }

  public dataCycleChange(value) {
    this.dataCycle = value

    this.documents = this.filterDocuments(
      this.state.getIn(['documents', 'data']),
    )
  }

  public filterDocuments(documents: any) {
    return documents.filter((document) =>
      this.dataCycle === DATA_CYCLE_FILTER.Current
        ? document.getIn(['dataCycle', 'id']) === this.currentDataCycleId
        : true,
    )
  }

  public download(document: any) {
    this.store.dispatch(
      new DownloadCompoundDocumentRequest({
        compoundId: this.compoundId,
        dataCycleId: document.getIn(['dataCycle', 'id']),
      }),
    )
  }

  public generate(document: any) {
    this.store.dispatch(
      new GenerateCompoundDocumentRequest({
        compoundId: this.compoundId,
        dataCycleId: document.getIn(['dataCycle', 'id']),
      }),
    )
  }

  public delete(document: any) {
    this.store.dispatch(
      new DeleteCompoundDocumentRequest({
        compoundId: this.compoundId,
        dataCycleId: document.getIn(['dataCycle', 'id']),
      }),
    )
  }

  public get isCurrentCycle() {
    return this.dataCycle === DATA_CYCLE_FILTER.Current
  }
}
